export const SUPPORTED_THEMES = {
  DEFAULT: 'DEFAULT',
  CARREFOUR: 'CARREFOUR',
  TRUFFAUT: 'TRUFFAUT',
};
